import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullComponent } from './shared/layout/full/full.component';
import { full } from './shared/routes/full.routes';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',

        loadChildren: () =>
          import('./shared/layout/layout.module').then((m) => m.LayoutModule),
      },
      {
        path: '',
        component: FullComponent,
        children: full,
      },
      { path: '**', redirectTo: '404', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
